import { render, staticRenderFns } from "./SettlementSummaryMetric.vue?vue&type=template&id=15b82e2c&scoped=true&lang=pug"
import script from "./SettlementSummaryMetric.vue?vue&type=script&lang=ts"
export * from "./SettlementSummaryMetric.vue?vue&type=script&lang=ts"
import style0 from "./SettlementSummaryMetric.vue?vue&type=style&index=0&id=15b82e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b82e2c",
  null
  
)

export default component.exports